/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_push.js                                                                           */
/**********************************************************************************************************************/
/* Subscriptions Custom */
HafasWebapp.prototype.subscriptions.Push  = function (_me) {
  Hafas.ps.sub('/push/setupAlarmType', Hafas.bind(_me.Controller.Push.setupAlarmType,_me));
  //Hafas.ps.sub('/push/subscriptionSuccess', Hafas.bind(_me.Controller.Push.hidePushOverlay,_me));

  /* Subscription actions */
  Hafas.ps.sub('/push/news', Hafas.bind(_me.Controller.Push.showMessages,_me));
  Hafas.ps.sub('/push/details', Hafas.bind(_me.Controller.Push.showDetails,_me));
  Hafas.ps.sub('/push/alternatives', Hafas.bind(_me.Controller.Push.showAlternatives,_me));
  Hafas.ps.sub('/push/edit', Hafas.bind(_me.Controller.Push.showEditDialog,_me));
  Hafas.ps.sub('/push/delete', Hafas.bind(_me.Controller.Push.deleteSubscription,_me));
  Hafas.ps.sub('/push/save', Hafas.bind(_me.Controller.Push.saveSubscription,_me));
  Hafas.ps.sub('/push/showRepeatOptions', Hafas.bind(_me.Controller.Push.showRepeatOptions,_me));
  Hafas.ps.sub('/push/acceptRepeat', Hafas.bind(_me.Controller.Push.acceptRepeatOptions,_me));
  Hafas.ps.sub("/push/updateWeekdaySelection", Hafas.bind(_me.Controller.Push.updateWeekdaySelection,_me));
  Hafas.ps.sub("/push/pauseAlarms", Hafas.bind(_me.Controller.Push.pauseAlarms,_me));

  // Aboeinstellungen
  Hafas.ps.sub('/push/changeNotificationOption', Hafas.bind(_me.Controller.Push.changeNotificationOption,_me));
  Hafas.ps.sub('/push/changeDelayOption', Hafas.bind(_me.Controller.Push.changeDelayOption,_me));

  Hafas.ps.sub('/push/toggleActionButtons', Hafas.bind(_me.Controller.Push.reRenderView,_me));

  Hafas.ps.sub('/push/selectChannel', Hafas.bind(_me.Controller.Push.selectChannel,_me));
  Hafas.ps.sub('/push/validateChannelInput', Hafas.bind(_me.Controller.Push.validateChannelInput,_me));

  Hafas.ps.sub('/GUI/closeView/Push', Hafas.bind(_me.Controller.Push.closeView,_me));
  Hafas.ps.sub('/GUI/restoreView/Push', Hafas.bind(_me.Controller.Push.restoreView,_me));

  // TP Modul wird verlassen
  Hafas.ps.sub('/GUI/leaveContext/Push', Hafas.bind(_me.Controller.Push.cleanup,_me));
};

